import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { ErrorHandler, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgJsonEditorModule } from "ang-jsoneditor";
import { ClickOutsideModule } from "ng-click-outside";
import { GooglePlaceModule } from "ngx-google-places-autocomplete";
import { LightboxModule } from "ngx-lightbox";
import { NgxPaginationModule } from "ngx-pagination";
import { PopoverModule } from "ngx-smart-popover";
import { AccordionModule } from "primeng/accordion";
import { MessageService, TreeDragDropService } from "primeng/api";
import { AutoCompleteModule } from "primeng/autocomplete";
import { CalendarModule } from 'primeng/calendar';
import { CarouselModule } from "primeng/carousel";
import { ContextMenuModule } from "primeng/contextmenu";
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from "primeng/dropdown";
import { FileUploadModule } from "primeng/fileupload";
import { InputTextModule } from 'primeng/inputtext';
import { MessagesModule } from "primeng/messages";
import { MultiSelectModule } from "primeng/multiselect";
import { OrderListModule } from "primeng/orderlist";
import { PickListModule } from "primeng/picklist";
import { RadioButtonModule } from "primeng/radiobutton";
import { TableModule } from "primeng/table";
import { ToastModule } from "primeng/toast";
import { ToggleButtonModule } from "primeng/togglebutton";
import { TooltipModule } from "primeng/tooltip";
import { TreeModule } from "primeng/tree";
import {TreeTableModule} from 'primeng/treetable';
import { i18nModule } from "../i18n.module";
import { MasterscreenService } from "../masterscreen/services/masterscreen.service";
import { CategoryComponent } from "./components/category/category.component";
import { ContractorLoginComponent } from "./components/contractor-login/contractor-login.component";
import { ExactLocationComponent } from "./components/exact-location/exact-location.component";
import { FaqComponent } from "./components/faq/faq.component";
import { FileViewerComponent } from "./components/file-viewer/file-viewer.component";
import { FilesPreviewerComponent } from "./components/files-previewer/files-previewer.component";
import { HeaderComponent } from "./components/header/header.component";
import { HomeComponent } from "./components/home/home.component";
import { LoginComponent } from "./components/login/login.component";
import { OrderListComponent } from "./components/order-list/order-list.component";
import { PageNotFoundComponent } from "./components/page-not-found/page-not-found.component";
import { PobaddMembersComponent } from "./components/pobadd-members/pobadd-members.component";
import { RecordActionsComponent } from "./components/record-actions/record-actions.component";
import { RemarksComponent } from "./components/remarks/remarks.component";
import { SideNavComponent } from "./components/side-nav/side-nav.component";
import { TextareaComponent } from "./components/textarea/textarea.component";
import { AlertsComponent } from "./directives/alerts/alerts.component";
import { FileUploadComponent } from "./directives/file-upload/file-upload.component";
import { RemainingCharactersComponent } from "./directives/remaining-characters/remaining-characters.component";
import { GoogleChartDirective } from "./directives/report/google-chart.directive";
import { AlphaNumericLimitedspecialcharactersDirective } from "./directives/validation/alpha-numeric-limitedspecialcharacters.directive";
import { AlphaNumericDirective } from "./directives/validation/alpha-numeric.directive";
import { DecimalDirective } from "./directives/validation/decimal.directive";
import { EmailValidator } from "./directives/validation/email-validation.directive";
import { NumberOnlyDirective } from "./directives/validation/number-only.directive";
import { ConvertToPriorityPipe } from "./pipes/convert-to-priority.pipe";
import { DateTimeFormat } from "./pipes/dateTimeFormat.pipe";
import { FileNamePipe } from "./pipes/file-name.pipe";
import { TableFilterPipe } from "./pipes/table-filter.pipe";
import { CustomLoaderService } from "./services/customloader.service";
import { HseErrorHandlerService } from "./services/hse-error-handler.service";
import { SharedRoutingModule } from "./shared-routing.module";
import { PdfViewerModule } from 'ng2-pdf-viewer';
import {TriStateCheckboxModule} from 'primeng/tristatecheckbox';
import { MenuComponent } from './components/menu/menu.component';
import { FooterComponent } from './components/footer/footer.component';
import { ReportLogComponent } from './components/report-log/report-log.component';
import {ImportErrorComponent} from './components/import-error/import-error.component';
import { ApproverLogComponent } from './components/approver-log/approver-log.component';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { AgmCoreModule } from '@agm/core';
import { ConstantsService } from "./services/constants.service";

@NgModule({
  imports: [
    AgmCoreModule.forRoot({
       
      apiKey: ConstantsService.URL.MAP_KEY
       
    }),
    CommonModule,
    FormsModule,
    SharedRoutingModule,
    CalendarModule,
    TooltipModule,
    DropdownModule,
    DialogModule,
    FileUploadModule,
    ClickOutsideModule,
    RadioButtonModule,
    AutoCompleteModule,
    TreeModule,
    TreeTableModule,
    TableModule,
    InputTextModule,
    ContextMenuModule,
    MultiSelectModule,
    CarouselModule,
    ToastModule,
    MessagesModule,
    AccordionModule,
    ToggleButtonModule,
    OrderListModule,
    LightboxModule,
    PopoverModule,
    NgJsonEditorModule,
    i18nModule,
    ReactiveFormsModule,
    GooglePlaceModule,
    PdfViewerModule,
    TriStateCheckboxModule,
    NgxDocViewerModule
  ],
  declarations: [
    HeaderComponent,
    NumberOnlyDirective,
    DecimalDirective,
    AlphaNumericDirective,
    AlphaNumericLimitedspecialcharactersDirective,
    PageNotFoundComponent,
    HomeComponent,
    SideNavComponent,
    AlertsComponent,
    LoginComponent,
    FileUploadComponent,
    ContractorLoginComponent,
    ConvertToPriorityPipe,
    EmailValidator,
    GoogleChartDirective,
    DateTimeFormat,
    FileNamePipe,
    RemainingCharactersComponent,
    PobaddMembersComponent,
    CategoryComponent,
    FileViewerComponent,
    FilesPreviewerComponent,
    TextareaComponent,
    RemarksComponent,
    RecordActionsComponent,
    OrderListComponent,
    ExactLocationComponent,
    FaqComponent,
    TableFilterPipe,
    MenuComponent,
    FooterComponent,
    ReportLogComponent,
    ImportErrorComponent,
    ApproverLogComponent
  ],
  exports: [
    FormsModule,
    CalendarModule,
    TooltipModule,
    DropdownModule,
    HttpClientModule,
    DialogModule,
    FileUploadModule,
    NgxPaginationModule,
    PickListModule,
    ClickOutsideModule,
    RadioButtonModule,
    TreeModule,
    TreeTableModule,
    TableModule,
    InputTextModule,
    ContextMenuModule,
    MultiSelectModule,
    HeaderComponent,
    NumberOnlyDirective,
    DecimalDirective,
    AlphaNumericDirective,
    AlphaNumericLimitedspecialcharactersDirective,
    SideNavComponent,
    AutoCompleteModule,
    AlertsComponent,
    FileUploadComponent,
    ConvertToPriorityPipe,
    EmailValidator,
    GoogleChartDirective,
    DateTimeFormat,
    FileNamePipe,
    RemainingCharactersComponent,
    CarouselModule,
    ToastModule,
    MessagesModule,
    ToggleButtonModule,
    AccordionModule,
    CategoryComponent,
    LightboxModule,
    FilesPreviewerComponent,
    PopoverModule,
    NgJsonEditorModule,
    TextareaComponent,
    RemarksComponent,
    RecordActionsComponent,
    OrderListModule,
    OrderListComponent,
    ExactLocationComponent,
    i18nModule,
    ReactiveFormsModule,
    TableFilterPipe,
    PdfViewerModule,
    TriStateCheckboxModule,
    MenuComponent,
    FooterComponent,
    ReportLogComponent,
    ImportErrorComponent,
    ApproverLogComponent,
    NgxDocViewerModule
  ],
  providers: [{ provide: ErrorHandler, useClass: HseErrorHandlerService }, MasterscreenService, CustomLoaderService, TreeDragDropService, MessageService]
})
export class SharedModule { }
